import React from "react";
import { connect } from "react-redux";
import type { ErrosSelecao } from "../../../model";
import {
  SelecaoDatasEspecificas,
  SelecaoCompetencia,
  SelecaoDataEspecifica,
  SelecaoMesAMes,
  SelecaoDiaADia,
  SelecaoJanela,
  validacaoSelecaoMesAMes,
  validacaoSelecaoDiaADia,
  validacaoSelecaoDataEspecifica,
  validacaoSelecaoDatasEspecificas,
} from "./periodosEstendidos";

function AreaPeriodosEstendido() {
  return (
    <>
      <SelecaoDatasEspecificas />
      <SelecaoDataEspecifica />
      <SelecaoCompetencia />
      <SelecaoMesAMes />
      <SelecaoDiaADia />
      <SelecaoJanela />
    </>
  );
}

export const validacaoPeriodosEstendidos = function(
  state: State
): ErrosSelecao {
  return {
    ...validacaoSelecaoDiaADia(state),
    ...validacaoSelecaoMesAMes(state),
    ...validacaoSelecaoDataEspecifica(state),
    ...validacaoSelecaoDatasEspecificas(state),
  };
};

export default connect(state => ({}), {})(AreaPeriodosEstendido);
